/* src/app/questionnaire/continue/continue.component.scss */
ion-button {
  --border-radius: 0;
}
/*# sourceMappingURL=continue.component.css.map */
